import { getBrandConfig } from '@/config/config'
import {
  initializeFaro,
  getWebInstrumentations,
  ReactIntegration,
  BaseInstrumentation,
} from '@grafana/faro-react'
import { Router } from '@tanstack/react-router'
import { routeTree } from '@/routeTree.gen'
import { getOidc } from '@/features/oidc/oidc'
import { EVENT_ROUTE_CHANGE } from '@grafana/faro-web-sdk'

type RouterType = Router<typeof routeTree, 'never', true>

export const initializeGrafanaIntegration = async (router: RouterType) => {
  const { grafana } = getBrandConfig()
  const oidc = await getOidc()

  if (grafana.isEnabled) {
    initializeFaro({
      url: grafana.url,
      app: { name: grafana.appName },
      sessionTracking: {
        enabled: true,
        session: {
          overrides: {
            serviceName: 'spa',
          },
          attributes: {
            userId: oidc.isUserLoggedIn
              ? oidc.getDecodedIdToken()['pam-aid']
              : '',
          },
        },
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new ReactIntegration(),
        new TanstackRouterIntegration(router),
      ],
    })
  }
}

class TanstackRouterIntegration extends BaseInstrumentation {
  readonly name = 'tanStackRouterIntegration'
  readonly version = '1.0.0'
  readonly router: RouterType

  constructor(router: RouterType) {
    super()
    this.router = router
  }

  initialize(): void {
    this.router.subscribe('onResolved', ({ fromLocation, toLocation }) => {
      this.api.pushEvent(EVENT_ROUTE_CHANGE, {
        toRoute: toLocation.pathname,
        toUrl: toLocation.href,
        fromRoute: fromLocation?.pathname || '',
        fromUrl: fromLocation?.href || '',
      })
    })
  }
}
